const VALID_DDD = '([14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])'
const VALID_MOBILE_NUMBER = `(${VALID_DDD}9[1-9]\\d{7})`

const VALID_SPECIALIZED_MOBILE_SERVICE =
  '(' +
  '1[1-9]7[0789]|' +
  '2[124]7[078]|' +
  '3[147]7[78]|' +
  '(' +
  '27|' +
  '4[1-478]|' +
  '5[14]|' +
  '6[125]|' +
  '7[135]|' +
  '8[15]' +
  ')78' +
  ')\\d{6}'

const MOBILE_NUMBER = new RegExp(`^(${VALID_MOBILE_NUMBER}|${VALID_SPECIALIZED_MOBILE_SERVICE})$`)

const LANDLINE_NUMBER = new RegExp(`^${VALID_DDD}[2345]\\d{7}$`)

const TOLL_FREE_NUMBER = new RegExp('^0800\\d{7}$')

const NATIONAL_NUMBER = new RegExp('^4004\\d{4}$')

export const removeMask = value => (typeof value === 'string' ? value.replace(/[^\d\*]/g, '') : '')

export const isMobileNumber = phoneNumber => !!MOBILE_NUMBER.exec(phoneNumber)
export const isLandlineNumber = phoneNumber => !!LANDLINE_NUMBER.exec(phoneNumber)
export const isTollFreeNumber = phoneNumber => !!TOLL_FREE_NUMBER.exec(phoneNumber)
export const isNationalNumber = phoneNumber => !!NATIONAL_NUMBER.exec(phoneNumber)
export const isLandline = phone =>
  /^\d+$/.test(removeMask(phone)) && removeMask(phone).length === 10

export const isValid = phoneNumber =>
  isLandlineNumber(phoneNumber) ||
  isMobileNumber(phoneNumber) ||
  isTollFreeNumber(phoneNumber) ||
  isNationalNumber(phoneNumber)

/*
 * formats:
 *    mobile:    21 2222 3333
 *    toll-free: 0800 123 1234
 */
export const getMaskedValue = (value, allowTollFree = false) => {
  const inputValue = value.replace(/[^\d\*]/g, '')
  const ret = {
    pretty: inputValue,
    clean: inputValue,
  }
  if (inputValue.length >= 3) {
    const isTollFree = allowTollFree && inputValue.substr(0, 4) === '0800'
    const isNational = inputValue.substr(0, 4) === '4004'

    if (isNational) {
      const prefix = inputValue.substr(0, 4)
      const sufix = inputValue.substr(4, 4)
      ret.pretty = `${prefix} ${sufix}`.trimEnd()
    } else if (isTollFree) {
      const prefix = inputValue.substr(0, 4)
      const first = inputValue.substr(4, 3)
      const second = inputValue.substr(7, 4)
      ret.pretty = `${prefix} ${first}-${second}`.trimEnd()
    } else {
      const ddd = inputValue.substr(0, 2)
      let rest = inputValue.substr(2)

      const isNineDigitNumber = rest.length >= 9 && (rest.startsWith('9') || rest.startsWith('*'))

      if (isNineDigitNumber) {
        rest = rest.substr(0, 9)
      } else {
        rest = rest.substr(0, 8)
      }

      let restOutput = rest
      if (rest.length >= 8) {
        const dividerIndex = Math.ceil(rest.length / 2)
        restOutput = `${rest.substr(0, dividerIndex)}-${rest.substr(dividerIndex)}`
      }

      ret.pretty = `(${ddd}) ${restOutput}`
      ret.clean = ddd + rest
    }
  }

  return ret
}

export const replaceDDD = phone => {
  const regexDDD = /\((\d{2})\)/
  return typeof phone === 'string' ? phone.replace(regexDDD, '(**)') : ''
}
